// Does not represent all possible properties

export enum TaxonomyItemCommonProperties {
  NAME = "name",
}

export enum TaxonomyItemPatientWeightProperties {
  MAX_WEIGHT_CAT = "maxWeightCat",
  MAX_WEIGHT_DOG = "maxWeightDog",
  MIN_WEIGHT_CAT = "minWeightCat",
  MIN_WEIGHT_DOG = "minWeightDog",
}

export enum FoodProductProperties {
  FOOD_BREED_SIZE = "food_breed_size",
  FOOD_PRODUCT = "foodProduct",
  GROUP = "group",
  LIFESTAGE = "lifestage",
  MARKETING_PRODUCT_LINE = "marketingProductLine",
  PACK_QUANTITY = "packQuantity",
  PACK_UNIT_VOLUME = "packUnitVolume",
  RANGE = "range",
  SUB_RANGE = "sub_range",
}

export enum MedicalProductProperties {
  DURATION_OF_EFFECT = "durationOfEffect",
  PACK_SIZE = "packSize",
  REGISTRATION_NUMBER = "registrationNumber",
  STRENGTH = "strength",
}

export enum RetailProductProperties {
  DURATION_OF_EFFECT = "durationOfEffect",
  PACK_SIZE = "packSize",
  PACK_UNIT_VOLUME = "packUnitVolume",
  STRENGTH = "strength",
}

export enum DiagnosticTestProperties {}
